
/* ============================== src/components/ProjectChat.jsx ============================== */
// src/components/ProjectChat.jsx
import { useCallback } from "react";
import Discussion from "./Discussion";

const EMPTY_ARRAY = Object.freeze([]);

export const ProjectChat = ({
  projectId,
  currentUser,
  toast,
  employees,
  candidates,
  openTask,
  tasks,
}) => {
  const handleTaskClick = useCallback(
    (taskId) => {
      openTask(taskId, "form", null, null, projectId, "chat");
    },
    [openTask, projectId],
  );

  return (
    <Discussion
      projectId={projectId}
      currentUser={currentUser}
      candidates={candidates || EMPTY_ARRAY}
      toast={toast}
      employees={employees}
      onTaskClick={handleTaskClick}
      showTaskLink={true}
      tasks={tasks || EMPTY_ARRAY}
    />
  );
};
